import { queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering } from "../../../../components/table/utils";
import { useDates } from "../../../../dates/DatesContext";

type Params = {
  filters?: ColumnFiltersState;
  search?: string;
  allActive: boolean;
};

export const useGetV4OrgReportByDate = (marketPlace: string) => {
  const { start, end, group, preStart, preEnd } = useDates();
  return (params: Params) => {
    const search = params.search ? params.search.split(",") : [];
    const filters = params.filters;
    return queryOptions({
      queryKey: [
        {
          entity: "getV4OrgReportByDate",
          marketPlace,
          params,
          dates: { start, end, preStart, preEnd, group },
        },
      ],
      queryFn: async () => {
        const res = await apiClient.getV4OrgReportByDate({
          queries: {
            marketplace: marketPlace,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
            start_date_previous: preStart.format("YYYY-MM-DD"),
            end_date_previous: preEnd.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(filters),
            date_group: group,
            search,
            all_active_orgs: params.allActive ? "true" : undefined,
          },
        });
        return res;
      },
    });
  };
};
